import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-account-identifier-card',
  templateUrl: './account-identifier-card.component.html',
  styleUrls: ['./account-identifier-card.component.scss']
})
export class AccountIdentifierCardComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

  // showDeleteIcon = true;
  @Input() showDeleteIcon;
  @Input() identifierInfo;
  @Output() deleteIdentifier = new EventEmitter;

  deleteIdentifierCard() {
    this.deleteIdentifier.emit(this.identifierInfo.id);
  }

}
